import type { TPreferences } from '../../entities/session';

export type TTheme = TPreferences['theme'];

// The shell reads the theme from localStorage on boot, so saving must write both it and the server.
const THEME_KEY = 'hp.theme';

export const applyTheme = (theme: TTheme): void => {
  const resolved =
    theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: light)').matches
        ? 'light'
        : 'dark'
      : theme;
  document.documentElement.dataset.theme = resolved;
  localStorage.setItem(THEME_KEY, theme);
};
